import { gql } from '@apollo/client';

import { Payment, CreatePaymentInput } from '../../../types/payments';
import { paymentFragment } from '../fragments';

export interface CreateAcademyPaymentMutationVariables {
  academyId: String;
  year: String;
  month: String;
  input: CreatePaymentInput;
}

export interface CreateAcademyPaymentMutationResult {
  payment: Payment;
}

export const createAcademyPaymentMutation = gql`
  mutation CreateAcademyPaymentMutation(
    $academyId: String
    $courseId: String!
    $year: String
    $month: String!
    $input: CreateAcademyPaymentMutationInput!
  ) {
    payment(academyId: $academyId, courseId: $courseId, year: $year, month: $month, input: $input)
      @rest(type: "Payment", path: "payments/{args.academyId}/{args.year}/{args.month}", method: "POST") {
      ...Payment
    }
  }
  ${paymentFragment}
`;
